import React, { useState, useEffect } from "react";
import { TextField, Button } from "@mui/material";
import CommonDialog from "../CommonDialog/CommonDialog";
import { addLibrary, updateLibrary } from "../../services/libraryService";
import { toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { PREDEFINED_LIBRARIES } from '../../constants/Constants';

const isPredefinedLibrary = (name) => {
  return PREDEFINED_LIBRARIES.includes(name.toLowerCase().trim());
};

const ManageLibrary = ({ libraryPopupOpen, handleClose, selectedLibrary, getLibraryData, userId, existingLibrary, onProtectedNameDetected, showWarning }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const mode = selectedLibrary ? "edit" : "add";

  useEffect(() => {
    if (libraryPopupOpen) {
      setName(mode === "edit" && selectedLibrary ? selectedLibrary.name : '');
      setError('');
    } else {
      setName('');
      setError('');
    }
  }, [libraryPopupOpen]);

  useEffect(() => {
    if (showWarning) {
      setName('');
      setError('');
    }
  }, [showWarning]);

  const validateName = (input) => {
    const trimmedInput = input.trim().toLowerCase();
    const originalName = selectedLibrary?.name?.trim().toLowerCase();

    if (!trimmedInput) {
      return 'Library name is required.';
    }

    const isDuplicate = (existingLibrary || []).some(lib => lib.name.trim().toLowerCase() === trimmedInput &&
      (mode === "add" || trimmedInput !== originalName));

    if (isDuplicate) {
      return 'Library name already exists.';
    }
    return '';
  };

  const handleChange = (e) => {
    const input = e.target.value;
    setName(input);
    const errorText = validateName(input);
    setError(errorText);
  };

  const handleSubmit = async () => {
    const trimmedName = name.trim();
    const errorText = validateName(name);

    if (errorText) {
      setError(errorText);
      return;
    }

    if (isPredefinedLibrary(trimmedName)) {
      onProtectedNameDetected();
      return;
    }

      if (mode === "add") {
        const response = await addLibrary({ name: trimmedName, user_id: userId });
        if(!response.success) return;
        toast.success('Library added successfully.');
      } else {
        const resp = await updateLibrary({
          name: trimmedName,
          user_id: userId,
          library_id: selectedLibrary.library_id
        });
        if(!resp.success) return;
        toast.success('Library updated successfully.');
      }
      if (getLibraryData) {
        await getLibraryData();
      }
      handleClose();
  };

  return (
    <CommonDialog open={libraryPopupOpen} onClose={handleClose} title={mode === "add" ? "Add Library" : "Edit Library"}>
      <TextField
        fullWidth
        id="title"
        variant="outlined"
        margin="normal"
        label="Library Name"
        value={name}
        onChange={handleChange}
        error={!!error}
        helperText={error}
        inputProps={{ maxLength: 75 }}
      />
      <>
        <Button variant="outlined" onClick={handleClose} startIcon={<CancelIcon />}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!!error || !name.trim()}
          startIcon={mode === "add" ? <AddIcon /> : <SaveIcon />}
        >
          {mode === "add" ? "Add" : "Save"}
        </Button>
      </>
    </CommonDialog>
  );
};

export default ManageLibrary;
